import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable @repo/internal/react/require-jsdoc */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { components } from 'react-select';
import DownIcon from '@atlaskit/icon/utility/migration/chevron-down';
import CrossIcon from '@atlaskit/icon/utility/migration/cross-circle--select-clear';
import { Inline, Pressable, xcss } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
const iconContainerStyles = xcss({
  all: 'unset',
  outline: 'revert',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 'space.025'
});
const dropdownWrapperStyles = xcss({
  padding: 'space.075'
});
export const ClearIndicator = props => jsx(components.ClearIndicator, _extends({}, props, {
  innerProps: {
    ...props.innerProps,
    'aria-hidden': 'false'
  }
}), jsx(Pressable, {
  xcss: iconContainerStyles,
  tabIndex: -1
}, jsx(CrossIcon, {
  label: "clear",
  color: "currentColor",
  LEGACY_size: "small",
  LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
})));
export const DropdownIndicator = props =>
// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
jsx(components.DropdownIndicator, props, jsx(Inline, {
  as: "span",
  xcss: dropdownWrapperStyles
}, jsx(DownIcon, {
  color: "currentColor",
  label: "open",
  LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
})));
export const LoadingIndicator = props => {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  const loadingStyles = css(props.getStyles('loadingIndicator', props));
  return (
    // This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    jsx("div", _extends({
      css: loadingStyles
    }, props.innerProps), jsx(Spinner, {
      size: "small"
    }))
  );
};